export default __webpack_public_path__ + "static/media/message_pink.3b52b420.svg";